import { decorate, observable } from 'mobx';
import ListData from '../toolkit/mobx-connectors/observables/list-data';

class MercaderiaStore {
  list = new ListData();
}

decorate(MercaderiaStore, {
  list: observable
});

const mercaderiaStore = new MercaderiaStore();
export default mercaderiaStore;
